export const inputLaraThemeConfig = {
  colorScheme: {
    light: {
      disabledBackground: "{gray-50}",
      disabledColor: "{gray-500}",
      focus: {
        ringShadow: "none",
        ringOutline: "0",
        borderColor: "{primary-500}",
      },
      borderRadius: "var(--radius-8)",
      borderColor: "{gray-300}",
      shadow: "var(--shadow-xs)",
    },
  },
  css: ({ dt }: any) => `
    .p-inputtext:enabled:focus {
      border: 2px solid var(--p-inputtext-focus-border-color);
    }
    .p-inputtext:enabled:focus.invalid-input {
      border: 2px solid var(--p-red-500);
    }
    .p-inputtext-sm {
      line-height: ${dt("formField.sm.lineHeight")};
      @media(max-width: 576px) {
        --p-inputtext-sm-font-size: 14px;
        --p-inputtext-sm-padding-y: 4px;
        --p-inputtext-sm-padding-x: 8px;
      }
    }
    .p-inputtext:enabled:hover.p-inputtext.invalid-input, .p-inputtext.invalid-input {
      border-color: var(--p-red-300)
    }
    .p-inputtext[readonly] {
      background: var(--p-gray-50);
      color: var(--p-gray-500);
      &:focus, &:hover {
        border: 1px solid var(--p-gray-300)
      }
    }
  `,
};
